module.exports = __webpack_public_path__ + "static/media/skincarepro_score_decile.4578233f.png";